import React, { useRef, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.svg";
import emailjs from '@emailjs/browser';

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);
const Error = tw.span`text-red-500`
const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`;
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`;
const Textarea = styled(Input).attrs({as: "textarea"})`
  ${tw`h-24`}
`;
const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`;
export default ({
  subheading = "Contacto",
  heading = <>Peça já o seu<span tw="text-primary-500"> orçamento.</span><wbr/></>,
  description = "Estamos aqui para ajudar! Se precisar de um orçamento personalizado para os nossos serviços de administração de condomínios ou se tiver alguma dúvida, por favor, não hesite em contactar-nos.",
  submitButtonText = "Enviar",
  formRef = useRef(),
  formMethod = "get",
  textOnLeft = true,
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const [errors,setErrors] = useState({});
  const validateForm = (data) => {
      const errors = {};

      if (!data.get('name').trim()) {
          errors.nome = 'Por favor, preencha o seu nome.';
      }

      if (!data.get('email').trim()) {
          errors.email = 'Por favor, preencha o seu Email.';
      } else if (!/\S+@\S+\.\S+/.test(data.get('email'))) {
          errors.email = 'Por favor, preencha corretamente o seu Email.';
      }

      if (!data.get('subject').trim()) {
        errors.assunto = 'Por favor, preencha o assunto';
      }
      if (!data.get('message').trim()) {
        errors.mensagem = 'Por favor, preencha a mensagem';
      }
      return errors;
  };
  const sendEmail = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    if (formData.get('field')) {
      return;
    }
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      emailjs.sendForm('service_xkn720g', 'template_3lu8yqr', formRef.current, {
        publicKey: '-TjQPaT1RP8gCKa_Z',
      }).then(() => {
        if(!alert('A sua mensagem foi enviada, entraremos em contato assim que possivel, obrigado!')){
          window.location.reload();
        }
      },(error) => {
        alert('Falhou: ' + error.text);
      });
    }
  };
  return (
    <Container id='contacto'>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
            <Form ref={formRef} method={formMethod} onSubmit={sendEmail}>
              <Input type="email" name="email" placeholder="O seu endereço de Email" />
              {errors.email && <Error >{errors.email}</Error>}
              <Input type="text" name="name" placeholder="O seu nome" />
              {errors.nome && <Error> {errors.nome} </Error>}
              <Input type="text" name="subject" placeholder="Assunto" />
              {errors.assunto && <Error> {errors.assunto} </Error>}
              <Textarea name="message" placeholder="A sua mensagem" />
              {errors.mensagem && <Error> {errors.mensagem} </Error>}
              <input name='field' placeholder='' type='hidden' />
              <SubmitButton type="submit">{submitButtonText}</SubmitButton>
            </Form>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
